export default "__VITE_ASSET__BBtCBvGF__"